import script from "./ViewDefineEmits.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDefineEmits.vue?vue&type=script&setup=true&lang=js"

import "./ViewDefineEmits.vue?vue&type=style&index=0&id=09786c65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09786c65"]])

export default __exports__